import config from "@/modules/config";

/** A retailer link on an article. */
export interface ArticleUrl {
  url: string;
  idmerchant?: unknown;
}

/** What a tap on an article's retailer link does. */
export type ArticleLinkOutcome =
  | { kind: "sheet" }
  | { kind: "open"; url: string; idmerchant?: unknown }
  | { kind: "none" };

/** Several retailers open the action sheet, one opens its URL, none does nothing. */
export function articleLinkOutcome(
  urls: ArticleUrl[] | undefined,
): ArticleLinkOutcome {
  if (urls && urls.length > 1) {
    return { kind: "sheet" };
  }
  const first = urls?.[0];
  const url = config.updatedLinkFromUrl(first?.url);
  if (!first || !url) {
    return { kind: "none" };
  }
  return { kind: "open", url, idmerchant: first.idmerchant };
}
